import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return (
      <footer className="app-footer">
        QT &copy; 2017 creativeLabs.
        <span className="float-right">{''}<a href="https://genesisui.com">{''}</a></span>
      </footer>
    )
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./components/Footer/index.js